import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

export const NoActiveRequestsError = () => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('no_active_requests');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.noActiveRequests.img.src}`}
      iconSize={content.noActiveRequests.img.width}
      title={content.noActiveRequests.title[locale]}
      titleSize={24}
      body={content.noActiveRequests.description[locale]}
    />
  );
};
